import Image from 'next/image'
import { forwardRef, useImperativeHandle, useRef } from 'react'

import { Chip, Text } from '@/shared/ui'

import cl from './message-empty-window.module.scss'

const QUESTION_TEMPLATES = [
	'Что с моим заказом?',
	'Поменяй стиль разговора',
	'Программа лояльности',
	'Ищу хорошие наушники',
	'Выгодные акции',
	'Хочу записаться в сервис'
]

export type MessageEmptyWindowHandle = {
	scrollToBottom: () => void
}

type MessageEmptyWindowProps = {
	setStartText: (value: string) => void
}

export const MessageEmptyWindow = forwardRef<MessageEmptyWindowHandle, MessageEmptyWindowProps>(
	({ setStartText }, ref) => {
		const containerRef = useRef<HTMLDivElement>(null)

		useImperativeHandle(ref, () => ({
			scrollToBottom: () => {
				if (containerRef.current) {
					containerRef.current.scrollTop = containerRef.current.scrollHeight
				}
			}
		}))

		return (
			<div className={cl.messageEmptyWindow} ref={containerRef}>
				<div className={cl.messageEmptyWindow__inner}>
					<Image
						alt=""
						width={200}
						height={200}
						className={cl.messageEmptyWindow__botImage}
						src="/empty_chat_list_image.png"
					/>
					<div className={cl.messageEmptyWindow__textBlock}>
						<Text weight="semibold">Добро пожаловать в iPort 🤖</Text>
						<Text>Я — ИИ-помощник. Знаю всё про Apple и не только.</Text>
						<Text>Помогу подобрать идеальное устройство, аксессуар или рассказать про услуги сервисных центров.</Text>
					</div>
					<div className={cl.messageEmptyWindow__questionWrap}>
						{QUESTION_TEMPLATES.map(question => (
							<Chip onClick={() => setStartText(question)} label={question} key={question} theme="accent" />
						))}
					</div>
				</div>

				<div className={cl.note}>
					<Text>
						Ответы ИИ-Помощника носят исключительно справочный характер и не являются консультацией или публичной
						офертой. При возникновении вопросов рекомендуем обратиться к продавцу. Начиная диалог, вы даете согласие на
						обработку своих персональных данных
					</Text>
				</div>
			</div>
		)
	}
)
